/**
 * 清除试题答案
 * 
 */
export const ClearAnswer = (ques) => {
    switch (ques.questionsTypeId) {
        case '6': // 图片选择
        case '8': // 单选题
        case '9': // 下拉框
        case '12': // 判断题
            ques.userAnswer = ''
            break;
        case '10': // 多选题
            ques.userAnswerArr = []
            break;
        default:
            break;
    }
    return ques
}